import { useFormatExport } from "./useFormatExport.ts";

const FALLBACK_FILE_NAME = "export.xlsx";

export interface UseExcelExportResult {
    exportExcel: (path: string, input: object) => Promise<boolean>;
    isExporting: boolean;
}

export function useExcelExport(): UseExcelExportResult {
    const { exportFile, isExporting } = useFormatExport(FALLBACK_FILE_NAME);

    return { exportExcel: exportFile, isExporting };
}
